import { useEffect, useState } from 'react';
import { FaCircle } from 'react-icons/fa';
import { getDeviceStatusCode } from 'utils/iconUtils';
import styles from './NodeStatusIcon.module.css';

const STATUS_GROUPS = {
  online: ['online', 'open'],
  alert: ['alerting', 'closed', 'flooding'],
  offline: ['offline'],
  neutral: ['warning', 'maintenance', 'slow', 'rising', 'dropping', 'idle'],
};

const getStatusVariant = (status) => {
  // Use a third neutral color for any non-online/offline/toggle status.
  const normalized = (status || 'offline').toLowerCase();
  if (STATUS_GROUPS.online.includes(normalized)) return 'online';
  if (STATUS_GROUPS.alert.includes(normalized)) return 'alert';
  if (STATUS_GROUPS.offline.includes(normalized)) return 'offline';
  return 'neutral';
};

export default function NodeStatusIcon({ device, size = 10 }) {
  const [status, setStatus] = useState();

  useEffect(() => setStatus(getDeviceStatusCode(device)), [device]);

  if (!device) return null;

  // Use the same display rule as NodeStatus: no data means Offline.
  const displayStatus = device.data ? status : 'Offline';
  const variant = getStatusVariant(displayStatus);

  return (
    <span className={styles.root} title={displayStatus || 'Offline'}>
      <FaCircle className={styles[variant]} style={{ fontSize: size }} />
    </span>
  );
}
